// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1HnVZ","inputWrap":"Table_inputWrap__2wcll","col":"Table_col__2nCn_","bmiTooltip":"Table_bmiTooltip__3p3s3"};